import { apiRequest } from './api';

export const getProtocols = () =>
  apiRequest('GET', '/protocols');

export const getTemplateProtocols = () =>
  apiRequest('GET', '/protocols/templates');

export const getProtocol = (id: string) =>
  apiRequest('GET', `/protocols/${id}`);

export const createProtocol = (data: any) =>
  apiRequest('POST', '/protocols', data);

export const updateProtocol = (id: string, data: any) =>
  apiRequest('PUT', `/protocols/${id}`, data);

export const deleteProtocol = (id: string) =>
  apiRequest('DELETE', `/protocols/${id}`);


// Console accessible debug methods available in development mode
if(process.env.NODE_ENV === 'development') {
  window.getProtocols = getProtocols;
  window.getTemplateProtocols = getTemplateProtocols;
  window.getProtocol = getProtocol;
  window.createProtocol = createProtocol;
  window.updateProtocol = updateProtocol;
  window.deleteProtocol = deleteProtocol;
}